import { Icon, Typography } from '@repo/ui';
import c from 'classnames';
import { Card } from 'components';
import {
  MARKED_IN_SURVEY_HOME_LABEL,
  MarkedInSurveyBadge,
} from '../MarkedInSurveyBadge';
import styles from './ConditionLinkCard.module.css';

type ConditionLinkCardProps = {
  name: string;
  /** Goes to `Card`'s `clickable`, so a bare slug resolves against the current route. */
  href?: string;
  /** Renders the tinted "marked in survey" header band + highlighted border. */
  markedInSurvey?: boolean;
  /** Fired on tap, alongside the card's own navigation. */
  onClick?: () => void;
  /** Between the name and the chevron. */
  trailing?: React.ReactNode;
  /** Below the name row. */
  children?: React.ReactNode;
  className?: string;
};

export default function ConditionLinkCard({
  name,
  href,
  markedInSurvey = false,
  onClick,
  trailing,
  className,
  children,
}: ConditionLinkCardProps) {
  const clickableData = href ? { href, text: '' } : undefined;

  return (
    <Card
      clickable={clickableData}
      onClick={onClick}
      className={c(
        styles.container,
        markedInSurvey && styles.markedCard,
        className,
      )}
      cardBodyClassName={c(
        markedInSurvey && styles.markedBody,
        styles.linkCardBody,
      )}
    >
      {markedInSurvey && (
        <div className={styles.markedHeader}>
          <MarkedInSurveyBadge label={MARKED_IN_SURVEY_HOME_LABEL} />
        </div>
      )}
      <div className={c(styles.card, markedInSurvey && styles.markedContent)}>
        <div className={styles.nameRow}>
          <Typography variant='body-s' className={styles.name}>
            {name}
          </Typography>
          <div className={styles.trailing}>
            {trailing}
            <Icon name='chevronForward' size='s' />
          </div>
        </div>
        {children}
      </div>
    </Card>
  );
}
